<template>
    <b-sidebar
        id="media-form-sidebar"
        :visible="isMediaFormSidebarActive"
        bg-variant="white"
        sidebar-class="sidebar-lg"
        shadow
        backdrop
        no-header
        right
        @shown="getData(mediaGalleryData)"
        @hidden="resetForm"
        @change="(val) => $emit('update:is-media-form-sidebar-active', val)"
    >
        <template #default="{ hide }">
            <div
                class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
            >
                <h5 class="mb-0">Media Form</h5>
                <feather-icon
                    class="ml-1 cursor-pointer"
                    icon="XIcon"
                    size="16"
                    @click="close(hide)"
                />
            </div>
            <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
                <b-form
                    class="p-2"
                    @submit.prevent="handleSubmit(onSubmit)"
                    @reset.prevent="resetForm"
                >
                    <b-tabs v-model="tabIndex">
                        <b-tab title="Content">
                            <b-tabs content-class="mt-1" v-if="langs.length > 0">
                                <b-tab
                                    v-for="(lang, key) in langs"
                                    :key="'tab-' + key"
                                    :title="lang.name"
                                >
                                    <validation-provider
                                        #default="validationContext"
                                        :name="'name_' + lang.code"
                                        rules="required"
                                    >
                                        <b-form-group
                                            label="Media Name"
                                            :label-for="'name_' + lang.code"
                                        >
                                            <b-form-input
                                                :id="'name_' + lang.code"
                                                v-model="Data.title[lang.code]"
                                                autofocus
                                                :state="getValidationState(validationContext)"
                                                trim
                                                :placeholder="'name (' + lang.code + ')'"
                                                @input="changeTitle(lang.code)"
                                            />
                                            <b-form-invalid-feedback>
                                                {{ validationContext.errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                    <validation-provider
                                        #default="validationContext"
                                        :name="'slug' + lang.code"
                                        rules="required"
                                    >
                                        <b-form-group
                                            label="Slug"
                                            :label-for="'slug' + lang.code"
                                        >
                                            <b-form-input
                                                :id="'slug' + lang.code"
                                                v-model="Data.slug[lang.code]"
                                                autofocus
                                                :state="getValidationState(validationContext)"
                                                trim
                                                :placeholder="'Slug (' + lang.code + ')'"
                                            />
                                            <b-form-invalid-feedback>
                                                {{ validationContext.errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                </b-tab>
                            </b-tabs>
                            <hr />
                            <validation-provider
                                #default="validationContext"
                                name="type"
                                rules="min:0"
                            >
                                <b-form-group label="Media Type" label-for="type_id">
                                    <v-select
                                        id="type_id"
                                        v-model="FileTypes"
                                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                        label="type"
                                        :options="
                                            mediaTypeData.map((g) => ({
                                                type: g.type,
                                                id: g.id,
                                            }))
                                        "
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <div v-if="(FileTypes.type && FileTypes.type === 'photo')">
                                <!-- <div v-if="Data.type"> -->
                                <b-button
                                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                    variant="outline-primary"
                                    class="mr-2"
                                    @click="uploadFiles('image')"
                                >
                                    Upload Image
                                </b-button>
                                <file-lists
                                    :is-modal-file-lists-show.sync="isModalFileListsShow"
                                    :uploadType="uploadType"
                                    @refesh="reloadData"
                                />
                                <br/>
                                <validation-provider
                                    #default="validationContext"
                                    name="cover_image_id"
                                    rules="required"
                                >
                                <br/>
                                    <b-form-group label-for="image">
                                        <div id="cover_image_id">
                                            <treeselect 
                                                @input="eventSelected"
                                                v-model="model" 
                                                placeholder="Choose Folder"
                                                :reduce="(option) => option.id"
                                                label="title"
                                                :options="folderOptions"
                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                noChildrenText
                                            />
                                        </div>
                                        <div>
                                            <b-container align-h="center">
                                                <b-row>
                                                    <b-col 
                                                        cols="3"
                                                        v-for="(image, index) in images"
                                                        :key="index"
                                                        class="pt-2"
                                                    >
                                                    <img 
                                                        v-if="image.types !== 'o'"
                                                        @click="eventImgSelected(image)"
                                                        :src="image.path"
                                                        width="300"
                                                        height="200"
                                                        :class="selectedImages.some(v => v.id == image.id)? 'selected-img' : ''"
                                                    >
                                                    <br/>
                                                </b-col>
                                                </b-row>
                                            </b-container>
                                        </div>
                                        <b-form-invalid-feedback>
                                            {{ validationContext.errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </validation-provider>
                            </div>
                            <div v-if="(FileTypes.type && FileTypes.type === 'video')">
                                <b-button
                                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                    variant="outline-primary"
                                    class="mr-2"
                                    @click="uploadFiles('video')"
                                >
                                    Upload Video
                                </b-button>
                                <file-lists
                                    :is-modal-file-lists-show.sync="isModalFileListsShow"
                                    :uploadType="uploadType"
                                    @refesh="reloadData"
                                />
                                <validation-provider
                                    #default="validationContext"
                                    name="video_id"
                                    rules="required"
                                >
                                <b-form-group>
                                    <div id="video">
                                        <br/>
                                        <treeselect 
                                            @input="eventSelected"
                                            v-model="model" 
                                            placeholder="Choose Folder"
                                            :reduce="(option) => option.id"
                                            label="title"
                                            :options="folderOptions"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            noChildrenText
                                        />
                                    </div>
                                    <div>
                                        <b-container>
                                            <b-row class="text-center">
                                                <b-col 
                                                    cols="2"
                                                    v-for="(image, index) in images"
                                                    :key="index"
                                                    class="pt-2"
                                                >
                                                <div
                                                    @click="eventvideoSelected(image)"
                                                    :class="selectedVideoFiles.some(v => v.id == image.id)? 'selected-img' : ''"
                                                    v-if="image.types !== 'i'"
                                                >
                                                    <feather-icon
                                                        icon="FileIcon"
                                                        size="62"
                                                    />
                                                    <div>
                                                        <strong>{{ image.name }}</strong>
                                                    </div>
                                                </div>
                                                    <br/>
                                                </b-col>
                                            </b-row>
                                        </b-container>
                                    </div>
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                                </validation-provider>
                            </div>
                            <validation-provider
                                #default="validationContext"
                                name="IsActive"
                                rules="required"
                            >
                                <b-form-group label="Is Active" label-for="IsActive">
                                    <b-form-checkbox
                                        id="isactive"
                                        checked="true"
                                        class="custom-control-success"
                                        v-model="Data.is_active"
                                        switch
                                    />
                                    <b-form-invalid-feedback>
                                    {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-tab>
                        <b-tab title="SEO">
                            <validation-provider
                                #default="validationContext"
                                name="meta_title"
                                rules="min:0"
                            >
                                <b-form-group label="Meta Title" label-for="meta_title">
                                <b-form-input
                                    id="meta_title"
                                    v-model="Data.meta_title"
                                    autofocus
                                    :state="getValidationState(validationContext)"
                                    trim
                                    placeholder="Meta Title"
                                />
                                <b-form-invalid-feedback>
                                    {{ validationContext.errors[0] }}
                                </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="validationContext"
                                name="meta_description"
                                rules="min:0"
                                
                            >
                                <b-form-group
                                label="Meta Description"
                                label-for="meta_description"
                                >
                                <b-form-input
                                    id="meta_description"
                                    v-model="Data.meta_description"
                                    autofocus
                                    :state="getValidationState(validationContext)"
                                    trim
                                    placeholder="Meta Description"
                                />
                
                                <b-form-invalid-feedback>
                                    {{ validationContext.errors[0] }}
                                </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="validationContext"
                                name="meta_keywords"
                                rules="min:0"
                            >
                                <b-form-group
                                    label="Meta Keywords"
                                    label-for="meta_keywords"
                                >
                                    <b-form-input
                                        id="meta_keywords"
                                        v-model="Data.meta_keyword"
                                        autofocus
                                        :state="getValidationState(validationContext)"
                                        trim
                                        placeholder="Meta Keywords"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-tab>
                    </b-tabs>
                    <div class="d-flex mt-2">
                        <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="outline-success"
                            class="mr-2"
                            type="submit"
                        >
                            Save
                        </b-button>
                        <b-button
                            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                            type="button"
                            variant="outline-danger"
                            @click="close(hide)"
                        >
                            Cancel
                        </b-button>
                    </div>
                </b-form>
            </validation-observer>
        </template>
    </b-sidebar>
    <!-- <upload-files-modal :is-modal-upload-files-show.sync="isModalUploadFilesShow" :parentData.sync="parent" :countFolder.sync="folders.length" @refetch-data="getAll" /> -->
</template>

<script>
import { $themeConfig } from '@themeConfig'
import {
    BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BFormInvalidFeedback,
    BButton, BTabs, BTab, BCard, BCardText, BFormRadio, BFormRadioGroup, BFormCheckboxGroup, BContainer,
    BRow, BCol
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { useToast } from "vue-toastification/composition";
import { ref, onUnmounted } from "@vue/composition-api";
import { slugify } from '@/@fake-db/utils'
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.core.css";
import "quill/dist/quill.bubble.css";
import Ripple from "vue-ripple-directive";
import store from "@/store";
import vSelect from "vue-select";
import languagesStoreModule from "@/views/languages/languagesStoreModule";
import formValidation from "@core/comp-functions/forms/form-validation";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import FileLists from '../uploadStorage/FileLists.vue';
import folderStoreModule from '../files/folderStoreModule'
import UploadVideoForm from './upload-video/UploadVideoForm.vue'
import FileList from '../files/files-list/FilesList.vue'

export default {
    components: {
        BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BFormInvalidFeedback,
        BButton, BTabs, BTab, BCard, BCardText, vSelect, ValidationProvider,
        ValidationObserver, BFormRadio, quillEditor, Treeselect, BFormRadioGroup, BFormCheckboxGroup,
        BContainer, BRow, BCol, FileLists, UploadVideoForm, FileList,
    },

    directives: {
        Ripple,
    },

    model: {
        prop: "isMediaFormSidebarActive",
        event: "update:is-media-form-sidebar-active",
    },

    props: {
        isMediaFormSidebarActive: {
            type: Boolean,
            required: true,
        },
        mediaGalleryData: {
            type: Object,
            required: false,
        },
    },

    computed: {
        currentLocale() {
            return this.$i18n.locale;
        },
        folderOptions(){
            return this.folders.map((folder) => this.formatFolder(folder))
        },
    },

    methods:{
        formatFolder(folder){
            return{
                id: folder.id,
                label: folder.title,
                children: folder.subFolders.length? folder.subFolders.map(this.formatFolder): undefined
            }
        },
    },

    setup(props, {emit}) {
        const {  appRef } = $themeConfig.app
        const toast = useToast();
        const userStorage = JSON.parse(localStorage.getItem('userData'));
        const getLocalSite = JSON.parse(localStorage.getItem('site'))
        const mediaTypeData = ref([])
        const isModalFileListsShow = ref(false)
        const isUploadModalActive = ref(false)
        const model = ref(null)
        const images = ref([])
        const selectedImages = ref([])
        const parent = ref(0);
        const folders = ref([])
        const uploadType = ref('')
        const blankData = {
            meta_title: '',
            meta_description: '',
            meta_keyword: '',
            title: {},
            slug: {},
            files: [],
            type: '',
            selectedFolderId: '',
            is_active: true,
            ordering_count: 0,
            sites_id: getLocalSite.id,
            created_by: userStorage.id,
        }
        const Data = ref(blankData);
        const tabIndex = ref(0);
        const langs = ref([]);
        const selectedVideoFiles = ref([])
        const FileTypes = ref({})
        const oldValue  =  ref(null)
        const selectedFolderId = ref('')

        const LANGUAGES_STORE_MODULE_NAME = "app-languages";
        if (!store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.registerModule(LANGUAGES_STORE_MODULE_NAME, languagesStoreModule);
        onUnmounted(() => {
            if (store.hasModule(LANGUAGES_STORE_MODULE_NAME))
            store.unregisterModule(LANGUAGES_STORE_MODULE_NAME);
        });

        const FOLDER_STORE_MODULE_NAME = 'files-folder'
        if (!store.hasModule(FOLDER_STORE_MODULE_NAME)) store.registerModule(FOLDER_STORE_MODULE_NAME, folderStoreModule)
        onUnmounted(() => {
            if (store.hasModule(FOLDER_STORE_MODULE_NAME)) store.unregisterModule(FOLDER_STORE_MODULE_NAME)
        });

        store.dispatch('app-media/getMediaTypes')
            .then((res) => {
                mediaTypeData.value = res.data.data
            })
            .catch((error) => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: "Error fetching images' list",
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                        text: error.response.data.message,
                    },
                })
            })

        const uploadFiles = (type) => {
            uploadType.value = type
            isModalFileListsShow.value = true
        }

        const uploadVideo = (type) => {
            uploadType.value = type
        }

        store.dispatch('files-folder/getFolders', {
            parent: parent.value,
            order_by:'ordering_count ASC'
        })
            .then(response => {
                const res = response?.data?.data
                if(!res.length) return
                folders.value = res
            })
            .catch((error) => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: "Error fetching images' list",
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                        text: error.response.data.message,
                    },
                })
            })

        const getData = async (data) => {
            tabIndex.value = 0;

            model.value = null
            images.value = []
            selectedImages.value = []
            selectedVideoFiles.value = []
            FileTypes.value = ''
            
            Data.value.meta_title = ''
            Data.value.meta_description = ''
            Data.value.meta_keyword = ''
            Data.value.title = {}
            Data.value.slug = {}
            Data.value.files = []
            Data.value.type = ''

            if(data) {

                data.is_active = data.is_active? true: false
                Data.value = data
                oldValue.value = JSON.parse(JSON.stringify({...data}))
                FileTypes.value = data?.type

                const files = data.files
                const folderId = data.selected_folder_id

                await store.dispatch('files-folder/getImagesByFolderId', folderId)
                    .then(response => {

                        images.value = response.data.data
                        model.value = folderId

                        if(FileTypes.value.type == 'photo'){
                            selectedImages.value = files
                        }

                        if(FileTypes.value.type == 'video'){
                            selectedVideoFiles.value = files
                        }
                        
                    })

            }
        }

        const reloadData = async () => {
            const files = Data.value.files

            if(files.length){
                const folderId = Data.value.selected_folder_id

                await store.dispatch('files-folder/getImagesByFolderId', folderId)
                    .then(response => {
                        images.value = response.data.data

                        model.value = folderId
                        selectedImages.value = files
                    }
                )
            }
        }

        const eventSelected = (id) => {
            selectedFolderId.value = id

            store.dispatch('files-folder/getImagesByFolderId', id)
                .then(response => {
                    const filterData = response.data.data

                    if(FileTypes.value.type == 'photo'){
                        images.value = filterData.filter((i) => i.types === 'i')
                    } else {
                        images.value = filterData.filter((i) => i.types === 'o')
                    }
                })
        }

        const selectedVideo = (data) => {
            selectedVideoFiles.value = data
            Data.value.files = data
        }

        const eventImgSelected = (data) => {
            const index = selectedImages.value.findIndex(item => item.id === data.id);
            index === -1 ? selectedImages.value.push(data) : selectedImages.value.splice(index, 1);
        }

        const eventvideoSelected = (data) => {
            const index = selectedVideoFiles.value.findIndex(item => item.id === data.id);
            index === -1 ? selectedVideoFiles.value.push(data) : selectedVideoFiles.value.splice(index, 1);
        }

        const onSubmit = function () {
            Data.value.is_active = Data.value.is_active?1:0;
            Data.value.type = FileTypes.value
            Data.value.selectedFolderId = selectedFolderId.value

            if(!Data.value.id){
                if(FileTypes.value.type === 'video') {
                    Data.value.files = selectedVideoFiles.value
                } else {
                    Data.value.files = selectedImages.value
                }

                store.dispatch('app-media/addMedia', Data.value)
                    .then((res) => {
                        toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: `Success`,
                                icon: 'BellIcon',
                                variant: 'success',
                                text: `${res.data.message}`,
                            },
                        });

                        emit('refetch-data')
                        emit('update:is-media-form-sidebar-active', false)
                    })
                    .catch((error) => {
                        toast({
                            component: ToastificationContent,
                            props: {
                                title: "Error insert media",
                                icon: 'AlertTriangleIcon',
                                variant: 'danger',
                                text: error.response.data.message,
                            },
                        })
                    })
            } else {
                if(FileTypes.value.type === 'video') {
                    Data.value.files = selectedVideoFiles.value
                } else {
                    Data.value.files = selectedImages.value
                }

                store.dispatch('app-media/updateMedia', Data.value)
                    .then((res) => {
                        toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: `Success`,
                                icon: 'BellIcon',
                                variant: 'success',
                                text: `${res.data.message}`,
                            },
                        });

                        emit('refetch-data')
                        emit('update:is-media-form-sidebar-active', false)
                    })
                    .catch((error) => {
                        toast({
                            component: ToastificationContent,
                            props: {
                                title: "Error insert media",
                                icon: 'AlertTriangleIcon',
                                variant: 'danger',
                                text: error.response.data.message,
                            },
                        })
                    })
            }
        }

        const resetData = () => {
            Data.value = blankData;
        };

        const changeTitle  = (lang) => {
            if(lang){
                Data.value.slug[lang] = slugify(Data.value.title[lang]);
            }
        }

        const getLangs = (filter) => {
            store.dispatch("app-languages/fetchData", filter).then((res) => {
                if (res.data.success) {
                    langs.value = res.data.data;
                }
            });
        };

        let filter = {
            is_active:1,
        }

        getLangs(filter)

        const close = (hidden) => {
            for(const lang in oldValue.value?.title ?? {}) {
                Data.value.title[lang] = oldValue.value.title[lang]
            }

            for(const lang in oldValue.value?.slug ?? {}) {
                Data.value.slug[lang] = oldValue.value.slug[lang]
            }

            hidden()
        }

        const {
            resetForm,
            getValidationState,
            refFormObserver
        } = formValidation(resetData);

        return {
            getData,
            resetForm,
            getValidationState,
            refFormObserver,
            tabIndex,
            langs,
            Data,
            mediaTypeData,
            uploadFiles,
            isModalFileListsShow,
            model,
            images,
            selectedImages,
            folders,
            eventSelected,
            eventImgSelected,
            onSubmit,
            changeTitle,
            uploadVideo,
            isUploadModalActive,
            uploadType,
            selectedVideo,
            selectedVideoFiles,
            FileTypes,
            reloadData,
            eventvideoSelected,
            close,
            oldValue,
        }
    }
}
</script>

<style lang="scss">
    @import "@core/scss/vue/libs/quill.scss";

    .selected-img{
        border: solid 5px #FFB341;
    }

    .disable-img{
        cursor: not-allowed;
        opacity: 0.5;
    }
</style>